<template>
  <div>
    <rest-form-item
      :label="$t('ChannelConfig_MessagebirdWhatsapp_AccessKey')"
      prop="access_key"
    >
      <el-input v-model="model.params.access_key" />
    </rest-form-item>

    <rest-form-item
      :label="$t('ChannelConfig_MessagebirdWhatsapp_Sandbox')"
      prop="sandbox"
    >
      <rest-form-select-boolean v-model="model.params.sandbox" />
    </rest-form-item>

    <rest-form-item
      v-if="model.params.sandbox"
      :label="$t('ChannelConfig_MessagebirdWhatsapp_SandboxOptinNumber')"
      prop="sandbox_optin_number"
    >
      <el-input
        v-model="model.params.sandbox_optin_number"
        placeholder="+44 7418 310508"
      />
    </rest-form-item>

    <rest-form-item
      v-if="model.params.sandbox"
      :label="$t('ChannelConfig_MessagebirdWhatsapp_SandboxOptinPhrase')"
      prop="sandbox_optin_phrase"
    >
      <el-input
        v-model="model.params.sandbox_optin_phrase"
        placeholder="join surfer unifier"
      />
    </rest-form-item>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'
import RestFormSelectBoolean from '@/common/components/rest/RestFormSelectBoolean'

export default {
  components: { RestFormSelectBoolean, RestFormItem },
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  created() {
    if (!this.$route.query.id) {
      this.$set(this.model, 'type', 'whatsapp')
      this.$set(this.model, 'channel', 'messagebird_whatsapp')
      this.$set(this.model, 'params', {
        sandbox: 0
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/channels/providers/MessageBirdWhatsapp.vue